import React from "react";
import { View } from "react-native";
import { colors } from "../../const";

export default function Stepper({ step, value }) {
    let data = [];
    if (!step) return null;
    for (let i = 0; i < step; i++) data.push(i+1);
    return (
        <View style={{ justifyContent: "center", flexDirection: "row", alignItems: "center", padding: 10 }} >
            {
                data.map((item) => <View style={[{
                    width: 14,
                    height: 14,
                    backgroundColor: item <= value ? colors.indigo : colors.lightGray,
                    borderRadius: 14 / 2,
                    margin: 2.5
                  }]} key={item}/>)
            }
        </View>
    )
}